import tracking from 'dibs-tracking';
import { getPromoCreative } from '../../helpers/getPromoCreative';

function trackFeaturedImpressions(items) {
    tracking.trackEcommerce({
        type: 'promotionImpression',
        promotions: items.map((item, index) => {
            const position = index + 1;
            return {
                id: 'five-brick-module',
                name: 'Five Brick Module',
                creative: getPromoCreative(item.link),
                position: position,
            };
        }),
    });
}

function trackFeaturedClick(item, index) {
    const position = index + 1;
    tracking.trackEcommerce({
        type: 'promoClick',
        promotions: [
            {
                id: 'five-brick-module',
                name: 'Five Brick Module',
                creative: getPromoCreative(item.link),
                position: position,
            },
        ],
    });
}

export { trackFeaturedImpressions, trackFeaturedClick };
